<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      :z-index="10"
      fixed
      title="我的积分"
      @click-left="goableBack()"></van-nav-bar>
    <div class="view-top-bg">
      <div class="top-contain-bg">
        <span class="top-name">{{ userInfo.name }}</span>
        <span class="top-grand">{{ userInfo.vipTitle || "普通会员" }}</span>
        <van-icon
          class="grand-icon"
          name="question-o"
          size="20"
          @click="getVipLevel" />
        <div class="integral-box">
          <div>
            <span>总积分：{{ userInfo.sumScore || 0 }}</span>
            <van-icon
              class="grand-icon"
              name="question-o"
              size="20"
              @click="getScoreTypeRule" />
          </div>
          <div>即将到期积分：{{ userInfo.willOutDateScore || 0 }}</div>
        </div>
        <div class="top-integralScale">
          <span>会员积分成长系数：{{ userInfo.coefficient }}</span>
          <van-icon
            class="score-icon"
            name="question-o"
            size="20"
            @click="getScoreCoefficient" />
        </div>
      </div>
    </div>
    <div class="integral-list">
      <div class="table-header-bg">
        <table>
          <caption>
            积分明细
          </caption>
          <thead>
            <tr>
              <th>日期</th>
              <th>类型</th>
              <th>积分变化</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-body-bg">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <!-- finished-text="没有更多了" -->
          <van-list
            class="list"
            v-model="loading"
            @load="onLoad"
            :finished="finished"
            :offset="10">
            <table>
              <tbody>
                <tr v-for="(item, i) of dataSource" :key="i">
                  <!-- <td>{{ item.createTime.split(" ")[0] }}</td> -->
                  <td>{{ dateFormat(item.createTime, "YYYY-MM-DD") }}</td>
                  <td>{{ item.changeReason }}</td>
                  <td>
                    {{ item.changeType == 1 ? "+" : "-" }}{{ item.score }}
                  </td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div v-if="finished" class="bottom-text">没有更多了</div>
    <!-- 会员等级标准 -->
    <van-popup
      closeable
      round
      close-icon="close"
      close-icon-position="top-right"
      v-model="showGrandRule"
      position="bottom"
      :style="{ height: '70%' }">
      <div class="pop-rule-main">
        <div class="fs-16 pop-rule-title">会员等级标准</div>
        <div class="item-bg">
          <van-cell v-for="(value, inde) in grands" :value="value" :key="inde">
          </van-cell>
        </div>
      </div>
    </van-popup>
    <!-- 会员等级积分系数 -->
    <van-popup
      closeable
      round
      close-icon="close"
      close-icon-position="top-right"
      v-model="showScoreRule"
      position="bottom"
      :style="{ height: '400px' }">
      <div class="pop-rule-main">
        <div class="fs-16 pop-rule-title">会员等级积分系数</div>
        <div class="score-list">
          <div class="table-body-bg">
            <table>
              <thead>
                <tr>
                  <th>会员等级</th>
                  <th>积分成长系数</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) of scores" :key="i">
                  <td>{{ item.vipTitle }}</td>
                  <td>{{ item.coefficient }}</td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 积分类型 -->
    <van-popup
      closeable
      round
      close-icon="close"
      close-icon-position="top-right"
      v-model="showGrandTypeRule"
      position="bottom"
      :style="{ height: '56%' }">
      <div class="pop-rule-main">
        <div class="fs-16 pop-rule-title">积分类型</div>
        <div class="item-bg">
          <van-cell
            v-for="(value, inde) in grandTypeRules"
            :value="value"
            :key="inde">
          </van-cell>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script >
import { Icon, List, Popup, PullRefresh } from "vant"
import * as MemberIntegralApi from "@/api/memberIntegral"
import { mapActions, mapGetters } from "vuex"
export default {
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Icon.name]: Icon,
    [Popup.name]: Popup
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      finished: false,
      refreshing: false,
      showGrandRule: false,
      showScoreRule: false,
      showGrandTypeRule: false,
      grands: [],
      scores: [],
      grandTypeRules: [],
      params: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.getUserInfo()
      .then((data) => {
        this.userInfo = data
      })
      .catch((e) => {})
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    onRefresh() {
      this.params.pageNum = 1
      this.onLoad()
    },
    onLoad() {
      MemberIntegralApi.getCustScoreRecord(this.params)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.params.pageNum === 1) {
              this.finished = false
              this.dataSource = data
              //赋值给数据源
            } else {
              this.dataSource = this.dataSource.concat(data)
            }
            if (data.length < this.params.pageSize) {
              this.finished = true
            } else {
              this.params.pageNum++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    // 获取持有金额会员等级区间
    getVipLevel() {
      MemberIntegralApi.getVipLevel()
        .then((data) => {
          if (data) {
            this.showGrandRule = true
            this.grands = []
            for (let index = 0; index < data.length; index++) {
              const element = data[index]
              if (element.floorAmount == 0 && element.upperAmount == 0) {
                this.grands.push(
                  index +
                    1 +
                    "、注册实名之后没有投资过的，会员等级为" +
                    element.title +
                    "；"
                )
              } else if (element.floorAmount > 0 && element.upperAmount == -1) {
                this.grands.push(
                  index +
                    1 +
                    "、存续期金额在" +
                    element.floorAmount +
                    "万元以上（含），会员等级为" +
                    element.title +
                    "；"
                )
              } else {
                if (element.floorAmount == 0) {
                  this.grands.push(
                    index +
                      1 +
                      "、存续期金额在" +
                      element.upperAmount +
                      "万元以下，会员等级为" +
                      element.title +
                      "；"
                  )
                } else {
                  this.grands.push(
                    index +
                      1 +
                      "、存续期金额在" +
                      element.floorAmount +
                      "万元（含）至" +
                      element.upperAmount +
                      "万元，会员等级为" +
                      element.title +
                      "；"
                  )
                }
              }
            }
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    getScoreTypeRule() {
      MemberIntegralApi.getScoreRules()
        .then((data) => {
          this.showGrandTypeRule = true
          this.grandTypeRules = data.split("</br>")
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    // 获取会员积分的系数
    getScoreCoefficient() {
      MemberIntegralApi.getScoreCoefficient()
        .then((data) => {
          if (data) {
            this.showScoreRule = true
            let vipTitles = []
            this.scores = []
            for (let index = 0; index < data.length; index++) {
              const element = data[index]
              if (element.coefficient == 1) {
                vipTitles.push(element.vipTitle)
              } else {
                this.scores.push({
                  vipTitle: element.vipTitle,
                  coefficient: element.coefficient
                })
              }
            }
            if (vipTitles.length > 0) {
              this.scores.unshift({
                vipTitle: vipTitles.join("、"),
                coefficient: 1
              })
            }
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.view-top-bg {
  background-image: url(../../assets/img/memberIntegral/mi_mineIntegral_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // background-attachment: fixed;
  .top-contain-bg {
    margin: 0 30px;
    padding-top: 50px;
    padding-bottom: 20px;
    color: white;
    font-size: 18px;
    font-weight: 900;

    .top-grand {
      padding: 5px;
      border: rgb(247, 206, 127) solid 2px;
      background-color: rgb(238, 150, 50);
      border-radius: 5px;
      margin-left: 10px;
    }
    .grand-icon {
      margin-left: 5px;
    }
    .integral-box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 15px;
    }
    .top-integralScale {
      font-size: 15px;
      .score-icon {
        margin-left: 5px;
      }
    }
  }
}
.integral-list {
  // Firefox4.0-
  -moz-box-shadow: 2px 2px 10px rgb(212, 214, 211);
  // Safariand Google chrome10.0-
  -webkit-box-shadow: 2px 2px 10px rgb(212, 214, 211);
  // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
  box-shadow: 2px 2px 10px rgb(212, 214, 211);
  margin: 15px;
  padding-bottom: 5px;
  background-color: white;
  border-radius: 10px;
  .table-header-bg {
    table {
      border-collapse: collapse;
      margin: 10px;
      width: calc(100vw - 14vw);
      margin-bottom: 0px;
      caption {
        margin: 15px 0;
        color: black;
        font-size: 16px;
        font-weight: 700;
      }
      th {
        color: rgb(105, 109, 111);
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        width: 100/3%;
      }
    }
  }
  .table-body-bg {
    overflow: auto;
    height: 240px;
    table {
      border-collapse: collapse;
      margin: 10px;
      width: calc(100vw - 14vw);
      margin-bottom: 20px;
      overflow: auto;
      td {
        width: 100/3%;
        color: rgb(138, 143, 143);
        font-size: 16px;
        font-weight: 500;
        height: 44px;
        text-align: center;
        border-top: 1px solid rgb(234, 234, 234);
      }
    }
  }
}
.bottom-text {
  text-align: center;
  color: rgb(145, 146, 148);
  font-size: 15px;
}
.pop-rule-main {
  display: flex;
  flex-direction: column;
  color: black;
  height: 100%;
  .pop-rule-title {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .item-bg {
    overflow-y: scroll;
  }
}
.score-list {
  margin: 15px;
  margin-top: 0px;
  background-color: white;
  overflow: hidden;
  .table-body-bg {
    overflow: auto;
    table {
      border-collapse: collapse;
      margin: 10px;
      width: calc(100vw - 14vw);
      margin-bottom: 20px;
      overflow: auto;
      th {
        color: rgb(105, 109, 111);
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        width: 100/2%;
        border: 1px solid rgb(203, 224, 241);
        height: 44px;
      }
      td {
        width: 100/2%;
        color: rgb(138, 143, 143);
        font-size: 14px;
        font-weight: 500;
        height: 44px;
        text-align: center;
        border: 1px solid rgb(203, 224, 241);
      }
    }
  }
}
</style>